var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallDownArrow = function SvgSmallDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323338",
    d: "M10 1.142 8.825 0 5 3.709 1.175 0 0 1.142 5 6z"
  })));
};
export default SvgSmallDownArrow;